import Vue from 'vue';

export interface RunnitMediaCacheStateLike {
	runnitState: {
		imageCache: Record<string, string>;
		videoCache: Record<string, string>;
	};
}

function cacheUrlInMap (cache: Record<string, string>, { filePath, url }: { filePath: string, url: string }): void {
	if (!filePath || !url) return;
	if (cache[filePath] === url) return;
	Vue.set(cache, filePath, url);
}

export function cacheRunnitImageUrlInState (
	state: RunnitMediaCacheStateLike,
	payload: { filePath: string, url: string },
): void {
	cacheUrlInMap(state.runnitState.imageCache, payload);
}

export function cacheRunnitVideoUrlInState (
	state: RunnitMediaCacheStateLike,
	payload: { filePath: string, url: string },
): void {
	cacheUrlInMap(state.runnitState.videoCache, payload);
}
